import { CtaButton } from './CtaButton';

interface Props {
  onOpenBot: () => void;
}

/**
 * "Two ways to order" — mirrors the Customer Website: same business, two front
 * doors (classic menu flow vs. conversational barista bot).
 */
export function HowItWorks({ onOpenBot }: Props) {
  return (
    <section
      id="how-it-works"
      aria-labelledby="how-heading"
      className="mx-auto max-w-6xl px-5 py-16 sm:py-20"
    >
      <div className="mx-auto max-w-2xl text-center">
        <h2 id="how-heading" className="text-3xl font-bold sm:text-4xl">
          Two ways to order
        </h2>
        <p className="mt-3 text-lg text-espresso-soft">
          Same coffee, same prices — pick whichever feels easier today.
        </p>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        <article className="flex flex-col rounded-[var(--radius-card)] bg-cream-50 p-7 ring-1 ring-mocha/15">
          <span aria-hidden="true" className="text-4xl">📋</span>
          <h3 className="mt-3 text-xl font-bold">Classic flow</h3>
          <p className="mt-2 flex-1 text-espresso-soft">
            Browse the menu, add what you like to your cart, and check out. Quick,
            visual, and familiar.
          </p>
          <div className="mt-5">
            <CtaButton href="#menu" variant="primary">
              Browse the menu
            </CtaButton>
          </div>
        </article>

        <article className="flex flex-col rounded-[var(--radius-card)] bg-cream-50 p-7 ring-1 ring-mocha/15">
          <span aria-hidden="true" className="text-4xl">💬</span>
          <h3 className="mt-3 text-xl font-bold">Conversational flow</h3>
          <p className="mt-2 flex-1 text-espresso-soft">
            Just tell our barista bot what you're craving — "a large oat latte,
            extra hot" — and it builds the order with you.
          </p>
          <div className="mt-5">
            <CtaButton
              onClick={onOpenBot}
              variant="secondary"
              ariaLabel="Ask our barista bot — opens a chat panel"
            >
              Ask our barista bot
            </CtaButton>
          </div>
        </article>
      </div>
    </section>
  );
}
